import { useDispatch, useSelector } from "react-redux";
import { ButtonBase } from "@mui/material";
import config from "config";
import logo from "../../../assets/images/Realestatily.png";
import { MENU_OPEN } from "store/actions";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase
      disableRipple
      onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
      to={config.defaultPath}
      style={{ display: "flex", alignItems: "center", gap: "8px" }}
    >
      <img
        src={logo}
        alt="Realestatily"
        style={{
          height: "26px",
          width: "auto",
          objectFit: "contain",
          mixBlendMode: "multiply",
        }}
      />
      <span style={{ fontWeight: "bold", fontSize: "1.1rem", color: "inherit" }}>
        
      </span>
    </ButtonBase>
  );
};

export default LogoSection;
